import {
    SET_TAB_INDEX,
    SET_CURRENT_POLYGON_IDS,
    SET_CURRENT_POLYGON_ID,
    SET_POLYGONS_AND_TITLES,
    FETCH_POLYGONS_REQUEST,
    FETCH_POLYGONS_SUCCESS,
    FETCH_POLYGONS_FAILURE,
    FETCH_INTERSECTIONS_REQUEST,
    FETCH_INTERSECTIONS_SUCCESS,
    FETCH_INTERSECTIONS_FAILURE,
    FETCH_NEARBY_REQUEST,
    FETCH_NEARBY_SUCCESS,
    FETCH_NEARBY_FAILURE,
    FETCH_PLANNING_REQUEST,
    FETCH_PLANNING_SUCCESS,
    FETCH_PLANNING_FAILURE,
    FETCH_VALUE_REQUEST,
    FETCH_VALUE_SUCCESS,
    FETCH_VALUE_FAILURE,
    FETCH_AREA_INFO_REQUEST,
    FETCH_AREA_INFO_SUCCESS,
    FETCH_AREA_INFO_FAILURE
} from './Types';

import axios from 'axios';
import { highlightFeatures } from '../highlights/Actions';
import { AreaInfo, Intersection, Polygon } from './parcelTypes';
const CancelToken = axios.CancelToken;
let cancelFetchPolygons: () => void,
    cancelFetchIntersections: () => void,
    cancelFetchNearby: () => void,
    cancelFetchPlanning: () => void,
    cancelFetchValue: () => void,
    cancelFetchAreaInfo: () => void;

const _setTabIndex = (index: number) => ({ type: SET_TAB_INDEX, index });
const _setCurrentPolygonIds = (polygonIds: Array<number | string>) => ({
    type: SET_CURRENT_POLYGON_IDS,
    polygonIds
});
const _setCurrentPolygonId = (polygonId: string) => ({ type: SET_CURRENT_POLYGON_ID, polygonId });
const _setPolygonsAndTitles = (polygons: Polygon[]) => ({
    type: SET_POLYGONS_AND_TITLES,
    polygons
});
const fetchPolygons = (polygonIds: Array<number | string>) => ({
    type: FETCH_POLYGONS_REQUEST,
    polygonIds
});
const fetchPolygonsSuccess = (bundle: any) => ({ type: FETCH_POLYGONS_SUCCESS, bundle });
const fetchPolygonsError = (polygonIds: Array<number | string>, error: string) => ({
    type: FETCH_POLYGONS_FAILURE,
    polygonIds,
    error
});
const fetchIntersections = (polygonId: number | string) => ({
    type: FETCH_INTERSECTIONS_REQUEST,
    polygonId
});
const fetchIntersectionsSuccess = (polygonId: number | string, intersections: Intersection[]) => ({
    type: FETCH_INTERSECTIONS_SUCCESS,
    polygonId,
    intersections
});
const fetchIntersectionsError = (polygonId: number | string, error: string) => ({
    type: FETCH_INTERSECTIONS_FAILURE,
    polygonId,
    error
});
const fetchNearby = (polygonId: number | string) => ({ type: FETCH_NEARBY_REQUEST, polygonId });
const fetchNearbySuccess = (polygonId: number | string, nearby: any) => ({
    type: FETCH_NEARBY_SUCCESS,
    polygonId,
    nearby
});
const fetchNearbyError = (polygonId: number | string, error: string) => ({
    type: FETCH_NEARBY_FAILURE,
    polygonId,
    error
});
const fetchPlanning = (polygonId: number | string) => ({ type: FETCH_PLANNING_REQUEST, polygonId });
const fetchPlanningSuccess = (polygonId: number | string, planning: any) => ({
    type: FETCH_PLANNING_SUCCESS,
    polygonId,
    planning
});
const fetchPlanningError = (polygonId: number | string, error: string) => ({
    type: FETCH_PLANNING_FAILURE,
    polygonId,
    error
});
const fetchValue = (polygonId: number | string) => ({ type: FETCH_VALUE_REQUEST, polygonId });
const fetchValueSuccess = (polygonId: number | string, value: any) => ({
    type: FETCH_VALUE_SUCCESS,
    polygonId,
    value
});
const fetchValueError = (polygonId: number | string, error: string) => ({
    type: FETCH_VALUE_FAILURE,
    polygonId,
    error
});
const fetchAreaInfo = (polygonId: number | string) => ({
    type: FETCH_AREA_INFO_REQUEST,
    polygonId
});
const fetchAreaInfoSuccess = (polygonId: number | string, areaInfo: AreaInfo) => ({
    type: FETCH_AREA_INFO_SUCCESS,
    polygonId,
    areaInfo
});
const fetchAreaInfoError = (polygonId: number | string, error: any) => ({
    type: FETCH_AREA_INFO_FAILURE,
    polygonId,
    error
});

// hmlr_land_parcels should be pulled from config
const highlightCurrentTitleConfig = (polygonId: string | number) => {
    return [
        {
            key: 'hmlr_land_parcels_current',
            layerSystemName: 'hmlr_land_parcels',
            features: [{ featureId: polygonId }]
        }
    ];
};

export const setTabIndex = (index: number) => {
    return (dispatch: (dispatch: any) => Promise<void>, getState: () => any) => {
        const { polygons, currentPolygonId } = getState().parcelPanel;
        const currentPolygon = polygons[currentPolygonId];
        dispatch(_setTabIndex(index));
        switch (index) {
            // Nearby tab
            case 1:
                // If not fetching and not already in cache then fetch nearby when going to tab
                if (
                    !currentPolygon ||
                    (!currentPolygon.isFetchingNearby && !currentPolygon.nearby)
                ) {
                    dispatch(fetchNearbyAsync(currentPolygonId));
                }
                break;
            // Planning tab
            case 2:
                // If not fetching and not already in cache then fetch nearby when going to tab
                if (
                    !currentPolygon ||
                    (!currentPolygon.isFetchingPlanning && !currentPolygon.planning)
                ) {
                    dispatch(fetchPlanningAsync(currentPolygonId));
                }
                break;
            // Value tab
            case 3:
                // If not fetching and not already in cache then fetch nearby when going to tab
                if (!currentPolygon || (!currentPolygon.isFetchingValue && !currentPolygon.value)) {
                    dispatch(fetchValueAsync(currentPolygonId));
                }
                break;
        }
    };
};

// ToDo replace hmlr_land_parcels with config
export const setCurrentPolygonId = (polygonId: string) => {
    return (dispatch: (dispatch: any) => Promise<void>, getState: () => any) => {
        const { polygons } = getState().parcelPanel;
        const weightingProfileId = 
            getState().user.prefs?.defaultAnalysisProfiles?.find(ap => ap.layerId === 159).profileId ||
            getState().user.features.analysis?.layers?.find(l => l.layerId === 159)?.profiles[0];
        const currentPolygon = polygons[polygonId];
        dispatch(_setCurrentPodefaultAnalysisProfileslygonId(polygonId));
        dispatch(highlightFeatures(highlightCurrentTitleConfig(polygonId)));
        // If not fetching and not already in cache then fetch area info for the first element
        if (!currentPolygon || (!currentPolygon.isFetchingAreaInfo && !currentPolygon.areaInfo)) {
            dispatch(fetchAreaInfoAsync(polygonId));
        }
        // If not fetching and not already in cache then all fetch intersections
        if (
            !currentPolygon ||
            (!currentPolygon.isFetchingIntersections && !currentPolygon.intersections)
        ) {
            dispatch(fetchIntersectionsAsync(polygonId, weightingProfileId));
        }
    };
};

export const setCurrentPolygonIds = (polygonsWithTitles: Polygon[]) => {
    return (dispatch: (dispatch: any) => Promise<void>, getState: () => any) => {
        const polygonIds = polygonsWithTitles.map(e => e.polygonId);
        dispatch(_setCurrentPolygonIds(polygonIds));
        dispatch(_setPolygonsAndTitles(polygonsWithTitles));
        if (polygonIds.length !== 0) {
            const { polygons } = getState().parcelPanel;
            const weightingProfileId = 
                getState().user.prefs?.defaultAnalysisProfiles?.find(ap => ap.layerId === 159).profileId ||
                getState().user.features.analysis?.layers?.find(l => l.layerId === 159)?.profiles[0];
            const currentPolygon = polygons[polygonIds[0]];
            dispatch(highlightFeatures(highlightCurrentTitleConfig(polygonIds[0])));
            // If not fetching and not already in cache then all fetch titles
            const newPolygonIds = polygonIds.filter(
                polygonId =>
                    !polygons[polygonId] ||
                    (!polygons[polygonId].isFetchingTile && polygons[polygonId].isLite)
            );
            if (newPolygonIds.length > 0) {
                dispatch(fetchPolygonsAsync(newPolygonIds));
            }
            // If not fetching and not already in cache then fetch area info for the first element
            if (
                !currentPolygon ||
                (!currentPolygon.isFetchingAreaInfo && !currentPolygon.areaInfo)
            ) {
                dispatch(fetchAreaInfoAsync(polygonIds[0]));
            }
            // If not fetching and not already in cache then all fetch intersections for the first element
            if (
                !currentPolygon ||
                (!currentPolygon.isFetchingIntersections && !currentPolygon.intersections)
            ) {
                dispatch(fetchIntersectionsAsync(polygonIds[0], weightingProfileId));
            }
        }
    };
};

export const fetchPolygonsAsync = (polygonIds: Array<number | string>) => {
    return async (dispatch: (dispatch: any) => Promise<void>) => {
        cancelFetchPolygons && cancelFetchPolygons();
        dispatch(fetchPolygons(polygonIds));
        return await axios
            .get('/api/parcels/overview', {
                params: { polygon_ids: polygonIds.join(',') },
                cancelToken: new CancelToken(c => {
                    cancelFetchPolygons = c;
                })
            })
            .then(response => {
                dispatch(fetchPolygonsSuccess(response.data));
            })
            .catch(error => {
                dispatch(fetchPolygonsError(polygonIds, error.response));
                console.error(error.response);
            });
    };
};

export const fetchIntersectionsAsync = (
    polygonId: number | string,
    weightingProfileId: number | string
) => {
    return async (dispatch: (dispatch: any) => Promise<void>) => {
        cancelFetchIntersections && cancelFetchIntersections();
        dispatch(fetchIntersections(polygonId));
        return await axios
            .get('/api/parcels/intersections', {
                params: { polygon_id: polygonId, weighting_profile_id: weightingProfileId },
                cancelToken: new CancelToken(c => {
                    cancelFetchIntersections = c;
                })
            })
            .then(response => {
                dispatch(fetchIntersectionsSuccess(polygonId, response.data));
            })
            .catch(error => {
                dispatch(fetchIntersectionsError(polygonId, error.response));
                console.error(error.response);
            });
    };
};

export const fetchNearbyAsync = (polygonId: number | string) => {
    return async (dispatch: (dispatch: any) => Promise<void>) => {
        cancelFetchNearby && cancelFetchNearby();
        dispatch(fetchNearby(polygonId));
        return await axios
            .get('/api/parcels/nearby', {
                params: { polygon_id: polygonId },
                cancelToken: new CancelToken(c => {
                    cancelFetchNearby = c;
                })
            })
            .then(response => {
                dispatch(fetchNearbySuccess(polygonId, response.data));
            })
            .catch(error => {
                dispatch(fetchNearbyError(polygonId, error.response));
                console.error(error.response);
            });
    };
};

export const fetchPlanningAsync = (polygonId: number | string) => {
    return async (dispatch: (dispatch: any) => Promise<void>) => {
        cancelFetchPlanning && cancelFetchPlanning();
        dispatch(fetchPlanning(polygonId));
        return await axios
            .get('/api/parcels/planning', {
                params: { polygon_id: polygonId },
                cancelToken: new CancelToken(c => {
                    cancelFetchPlanning = c;
                })
            })
            .then(response => {
                dispatch(fetchPlanningSuccess(polygonId, response.data));
            })
            .catch(error => {
                dispatch(fetchPlanningError(polygonId, error.response));
                console.error(error.response);
            });
    };
};

export const fetchValueAsync = (polygonId: number | string) => {
    return async (dispatch: (dispatch: any) => Promise<void>) => {
        cancelFetchValue && cancelFetchValue();
        dispatch(fetchValue(polygonId));
        return await axios
            .get('/api/parcels/value', {
                params: { polygon_id: polygonId },
                cancelToken: new CancelToken(c => {
                    cancelFetchValue = c;
                })
            })
            .then(response => {
                dispatch(fetchValueSuccess(polygonId, response.data));
            })
            .catch(error => {
                dispatch(fetchValueError(polygonId, error.response));
                console.error(error.response);
            });
    };
};

export const fetchAreaInfoAsync = (polygonId: number | string) => {
    return async (dispatch: (dispatch: any) => Promise<void>) => {
        cancelFetchAreaInfo && cancelFetchAreaInfo();
        dispatch(fetchAreaInfo(polygonId));
        return await axios
            .get('/api/parcels/area_info', {
                params: { polygon_id: polygonId },
                cancelToken: new CancelToken(c => {
                    cancelFetchAreaInfo = c;
                })
            })
            .then(response => {
                dispatch(fetchAreaInfoSuccess(polygonId, response.data));
            })
            .catch(error => {
                dispatch(fetchAreaInfoError(polygonId, error.response));
                console.error(error.response);
            });
    };
};
